import {
  ORDER_STATE_LABELS,
  ORDER_STATE_LABELS_ES,
} from '../../../../commons/const/orderStateLabels';

export const getOrderStateLabel = (stateId: string): string =>
  ORDER_STATE_LABELS[stateId as keyof typeof ORDER_STATE_LABELS] ?? stateId;

export const getOrderStateLabelEs = (state: string): string =>
  ORDER_STATE_LABELS_ES[state] ?? state;
